import { isPlatformServer } from '@angular/common'
import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, ElementRef, HostBinding, Input, OnInit, PLATFORM_ID, inject,
} from '@angular/core'
import {
  distinctUntilChanged, fromEvent, map,
} from 'rxjs'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { RouterOrExternalLinkDirective } from '@knorr-bremse-portals/ngx-components'

declare type NavigationLevel = NavigationItem[]
interface NavigationItem {
  label: string
  routerPath?: string
  children?: NavigationLevel
}

@Component({
  selector: 'kb-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOrExternalLinkDirective],
})
export class HeaderComponent implements OnInit {
  @Input()
  public logo?: {
    src: string
    alt: string
    href: string
  } | null

  @HostBinding('class.scrolled')
  protected scrolled = false

  private destroyRef = inject(DestroyRef)
  private hostElement = inject(ElementRef<HTMLElement>)
  private platformId = inject(PLATFORM_ID)
  private cdr = inject(ChangeDetectorRef)

  public ngOnInit(): void {
    this.setupScrolledObserver()
  }

  private setupScrolledObserver() {
    if (isPlatformServer(this.platformId)) {
      return
    }

    fromEvent(document, 'scroll').pipe(
      takeUntilDestroyed(this.destroyRef),
      map(() => {
        const currentHeight = this.hostElement.nativeElement.offsetHeight
        return window.scrollY > currentHeight
      }),
      distinctUntilChanged(),
    ).subscribe((scrolled) => {
      this.scrolled = scrolled
      this.cdr.markForCheck()
    })
  }
}
